import {Loading} from '@hm/fundamental'

import {useValidateDrillingSettings, useValidateHeatZones, useValidateKilnConfig} from './hooks'
import {KilnValidationError} from './KilnValidationError'

interface KilnValidationWrapperProps {
  children: React.ReactElement
}

export const KilnValidationWrapper: React.FC<KilnValidationWrapperProps> = ({children}) => {
  const {isKilngConfigValid, isKilnConfigLoading} = useValidateKilnConfig()
  const {areHeatZonesValid, areHeatZonesLoading} = useValidateHeatZones()
  const {areDrillingSettingsValid, areDrillingSettingsLoading} = useValidateDrillingSettings()

  const isKilnValidationInProgress =
    isKilnConfigLoading || areHeatZonesLoading || areDrillingSettingsLoading

  const isKilnValidForRefractoryPlanning =
    isKilngConfigValid && areHeatZonesValid && areDrillingSettingsValid

  if (isKilnValidationInProgress) {
    return (
      <div className="h-screen flex items-center justify-center">
        <Loading size="xlarge" data-cy="refra_planning_loader" />
      </div>
    )
  }

  if (!isKilnValidForRefractoryPlanning) {
    return (
      <KilnValidationError
        isKilngConfigValid={isKilngConfigValid}
        areHeatZonesValid={areHeatZonesValid}
        areDrillingSettingsValid={areDrillingSettingsValid}
      />
    )
  }

  return children
}
